<template>
  <div class="events">
    <VideoBanner v-if='$route.name === "Events"' posterSrc='party.jpg' mp4Src='party.mp4' webmSrc='party.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Events</h2>
        <div class="events-content page-content">
          <b-row>
            <b-col>
              <h3>Företagsevent</h3>
              <p>Vi erbjuder kompletta lösningar för företagsevent, från underhållning och aktiviteter till catering och teknik. Oavsett om det handlar om en konferens, kick-off, julfest eller en galamiddag, ser vi till att alla detaljer är på plats för att skapa ett minnesvärt event. Vi erbjuder även tält, bord, stolar och scener för att ge evenemanget rätt miljö.</p>
              <h3>PRIVATA FESTER</h3>
              <p>För privata fester, som bröllop, födelsedagar eller jubileer, erbjuder vi helhetslösningar som anpassas efter era önskemål. Vi hjälper er med allt från musik och underhållning till tekniska lösningar och dekor. Oavsett storlek på tillställningen ser vi till att varje detalj är noggrant planerad för att ge er och era gäster en fantastisk upplevelse.</p>
              <h3>HELHETSLÖSNINGAR FÖR DITT EVENT</h3>
              <p>Med vår erfarenhet och breda nätverk kan vi hjälpa er med alla aspekter av ert event, från planering till genomförande. Vi är er pålitliga partner för att skapa en smidig och professionell eventupplevelse.</p>
              <h3>MIDDAGSUNDERHÅLLNING</h3>
              <p>För att förhöja konferensmiddagar, galor eller privata tillställningar erbjuder vi proffsig middagsunderhållning. Från musik och sång under hela middagen till fördrinken och kaffet. Vi kan även krydda kvällen med en DJ eller ett partyband som håller energin uppe och får gästerna att dansa hela vägen fram till småtimmarna.</p>
              <p class="last-pop">Låt oss skapa det perfekta eventet för er!</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
